import { HttpService } from "@/core/index";
import {
  LoginReq,
  LoginResp,
  TenantReq,
  TenantResp,
  AuthLoginReq,
  AuthLoginResp,
  UserInfoResp,
  TenantCompanyResp,
  getPasswordReq,
} from "./login.interface";
import store from "@/store";
import { useIntervalFn } from "@vueuse/core";
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
export class LoginService {
  static useLoginApi() {
    const api = (data: LoginReq) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/loginVerify",
        data,
      });
    return HttpService.useRequest<LoginResp>(api);
  }

  static useTenantApi() {
    const api = (data: TenantReq) => {
      data["loginSource"] = IsZhiHuiXingHe() ? "zhxh" : "hhr";
      return HttpService.axios({
        method: "POST",
        url: "/auth/loginVerifySignatureBindTenants",
        data,
      });
    };
    return HttpService.useRequest<TenantResp>(api);
  }

  static useSelectTenants() {
    const api = () => {
      let data = { loginSource: IsZhiHuiXingHe() ? "zhxh" : "hhr" };
      return HttpService.axios({
        method: "POST",
        url: "/auth/selectBindTenants",
        data
      });
    };

    return HttpService.useRequest<TenantResp>(api);
  }

  static useSwitchTenantLoginApi() {
    const api = (tenantId: string) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/accessTokenSwitchTenantLogin",
        data: {
          tenantId,
          loginSource: "hhr",
        },
      });
    return HttpService.useRequest<AuthLoginResp>(api);
  }
  static clearInitStatus() {
    //初始化项目状态
    const api = () =>
      HttpService.axios({
        method: "POST",
        url: "/project/init/status",
      });
    return HttpService.useRequest<any>(api);
  }
  static useTenantLoginApi() {
    const api = (data: AuthLoginReq) => {
      return HttpService.axios({
        method: "POST",
        url: "/auth/selectTenantLogin",
        data,
      });
    };
    return HttpService.useRequest<AuthLoginResp>(api);
  }
  static useUserInfoApi(isOutError = false) {
    const api = (belongSystem) =>{
      if(!belongSystem) belongSystem = store.state.user.belongSystem
      return HttpService.axios({
        method: "GET",
        url: `/auth/selectUserInfoByaccessToken?belongSystem=${belongSystem}`,
      });
    }
      
    return HttpService.useRequest<UserInfoResp>(api, {
      isOutError,
      setStore: (data) => {
        store.commit("user/SET_INFOACCESSTOKEN", data);
      },
    });
  }
  static getTenantApplicationByTenantId() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/tenantApplication/getTenantApplicationByTenantId",
        data
      });
    return HttpService.useRequest<UserInfoResp>(api);
  }
  static saveTenantApplication() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/tenantApplication/saveTenantApplication",
        data
      });
    return HttpService.useRequest<UserInfoResp>(api);
  }
  static getTenantAdmin() {
    const api = (tenantId: string) =>
      HttpService.axios({
        method: "GET",
        url: `/relocation/tenant_admin/getTenantAdmin/${tenantId}`,
      });
    return HttpService.useRequest<any>(api);
  }

  /**
   * 租户查询往来单位
   */
  static useTenantCompanyApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/cooperation_company/contacts",
      });
    return HttpService.useRequest<TenantCompanyResp>(api);
  }

  /* 查询手机号是否注册 */
  static checkPhoneNum() {
    const api = (data: string, loginSource = "hhr") =>
      HttpService.axios({
        method: "GET",
        url: "/smallApp/auth/checkPhoneNum?phoneNum=" + data + "&&loginSource=" + loginSource,
      });
    return HttpService.useRequest<any>(api);
  }
  /* 获取验证码 */
  static getVerificationCode() {
    const api = (params: any) => {
      params["loginSource"] = IsZhiHuiXingHe() ? "zhxh" : "hhr";
      return HttpService.axios({
        method: "GET",
        url: "/verification_code",
        params,
      });
    };

    return HttpService.useRequest<any>(api);
  }

  /* 忘记密码修改密码 */
  static tenantUserResetPassword() {
    const api = (data: getPasswordReq) => {
      return HttpService.axios({
        method: "POST",
        url: "/auth/tenantUserResetPassword",
        data,
      });
    };
    return HttpService.useRequest<any>(api, {
      successRespCode: ["0000", "0003"],
    });
  }
  /**
   * 账号退出
   * @returns
   */
  static logoOut() {
    const api = () =>
      HttpService.axios({
        method: "POST",
        url: "/auth/loginOut",
      });
    return HttpService.useRequest<any>(api);
  }

  static getWxQrcode() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "/wx/weChat/image/url",
      });
    return HttpService.useRequest<any>(api, { isOutError: true, onError: () => {} });
  }

  static verifyRequestPath() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/verifyRequestPath",
        data
      });
    return HttpService.useRequest<any>(api);
  }
  static registerUser() {
    const api = (data) =>
      HttpService.axios({
        method: "POST",
        url: "/auth/registerUser",
        data
      });
    return HttpService.useRequest<any>(api);
  }
  static checkShareLink() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/electronicSignatureSalesmanShare/checkShareLink",
        params
      });
    return HttpService.useRequest<any>(api);
  }
}
